import {Component, OnInit} from '@angular/core';
import {SelectFieldOptionsService} from '../../services/select-field-options-service.service';

@Component({
    selector: 'app-select-field-options-editor',
    templateUrl: './select-field-options-edit.component.html',
    styleUrls: ['./select-field-options-edit.component.scss']
})
export class SelectFieldOptionsEditComponent implements OnInit {

    constructor(private service: SelectFieldOptionsService) {
    }

    ngOnInit() {
        this.service.getAll();
    }

}



// WEBPACK FOOTER //
// ./src/app/forms/components/select-field-options-edit/select-field-options-edit.component.ts